import { PageHeader } from 'antd'
import styled from 'styled-components'

const WrapContent = styled.div`
  background-color: #fff;
  display: flex;
`

const WrapHamburgermenu = styled.div`
  align-self: center;
  background-color: white;
  padding: 21px 24px;
`

const WrapPageHeader = styled(PageHeader)`
  width: 100%;
  .ant-page-header-heading {
    overflow: visible;
  }
`

export { WrapContent, WrapHamburgermenu, WrapPageHeader }
